import { useAtomValue } from "jotai";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { timelineFilterAtom } from "web_myplann/NotificationCenter/Atoms/timelineFilterAtom";
import type { NotificationCenterTab } from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import { timelineFilterSummary } from "web_myplann/NotificationCenter/Utils/timelineFilterSummary";
import { ListFilterChip } from "web_myplann/Shared/Components/Redesign/ListFilterChip";

type NotificationCenterFilterChipProps = {
	activeTab: NotificationCenterTab;
};

export const NotificationCenterFilterChip: FC<
	NotificationCenterFilterChipProps
> = ({ activeTab }) => {
	const { t } = useResource();
	const navigate = useNavigate();
	const filter = useAtomValue(timelineFilterAtom);

	return (
		<ListFilterChip
			summary={timelineFilterSummary(filter, activeTab, t)}
			onClick={() => navigate(Routing.NotificationsFilter.path(activeTab))}
			data-testid="notification-center-filter-button"
		/>
	);
};
